import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from './app-settings';
import { map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoreServiceService {

  public appSettings: AppSettings;
  constructor(private httpClient: HttpClient) {

  }
  loadAppSettings(): Promise<AppSettings> {
    return this.httpClient.get<AppSettings>('assets/ParkConfig.json?v=' + new Date().getTime()).pipe(map(res => {
      if (res) {
        this.appSettings = res;
        return res;
      }
      else {
        return undefined;
      }


    })).toPromise<AppSettings>();
  }
}
